<template>
    <div class="tabs">
      <ul>
        <li class="is-active"><a>Pictures</a></li>
        <li><a>Music</a></li>
        <li><a>Videos</a></li>
        <li><a>Documents</a></li>
      </ul>
    </div>
</template>

<script>
    export default {

        props: [
            'date'
        ],

        data() {
            return {
                // date: ''
            }
        },

        mounted() {
            console.log('Component mounted.');
        }
    }
</script>

<style>
    .panel {
        background: white;
        padding: 1.5rem;
    }
</style>